import {
  GET_TIME_SLOTS,
  GET_TIME_SLOTS_FAILURE,
  GET_TIME_SLOTS_SUCCESS,
} from './action';

const initialState = { loading: false, data: null, error: '' };

const getTimeSlotsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TIME_SLOTS:
      return { ...state, loading: true };
    case GET_TIME_SLOTS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_TIME_SLOTS_FAILURE:
      return { ...state, loading: false, data: null, error: action.payload };
    default:
      return state;
  }
};

export default getTimeSlotsReducer;
